// Multiplayer round-loop contracts. Defines the response envelope
// returned by /api/multi/* endpoints and the payload shapes for
// server-pushed socket.io events. Mirrors the discipline in solo.ts.
import { z } from 'zod';
export const MultiPhases = [
    'lobby',
    'shop',
    'battle',
    'between',
    'spectator',
    'done',
];
export const MultiPhaseSchema = z.enum(MultiPhases);
// Push event names — string-typed registry the client + server share
// so a typo'd event name fails loudly.
export const MULTI_SOCKET_EVENTS = {
    LobbyUpdate: 'lobby_update',
    MatchStart: 'match_start',
    RoundStart: 'round_start',
    ParticipantStateUpdate: 'participant_state_update',
    RoundBattleResolved: 'round_battle_resolved',
    SpectatorRound: 'spectator_round',
    MatchOver: 'match_over',
    Error: 'multi_error',
};
//# sourceMappingURL=multi.js.map